<template>
  <div class="color-preview" :style="isValidHexColor ? { backgroundColor: value } : null">
    <span v-if="!isValidHexColor">×</span>
  </div>
</template>

<script>
export default {
  name: 'ColorPreview',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    isValidHexColor() {
      return /^#[0-9A-F]{6}$/i.test(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.color-preview {
  width: 24px;
  height: 24px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;

  span {
    color: #999;
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
